import { usePolledCounter } from "@hiya/ui";
import { getUnreadCount } from "../api/notifications";

const POLL_INTERVAL = 30_000;

export function useUnreadCount() {
  const { data: count, refresh } = usePolledCounter(
    getUnreadCount,
    0,
    POLL_INTERVAL,
  );
  return { count, refresh };
}
